<template>
  <div class="header">
    <div class="top">
      <div class="img">
        <img src="@/assets/images/logo.png" alt="">
      </div>
      <div class="right" @click="showNav">
        <img src="@/assets/images/navRight.png" alt="">
      </div>
    </div>
    <div class="nav" v-if="show">
      <router-link to="/" tag="div" class="logo" active-class="actives" exact><div>首页 </div></router-link>
      <router-link to="/course" tag="div" class="logo" active-class="actives"><div>线上课程</div></router-link>
      <router-link to="/serve" tag="div" class="logo" active-class="actives"><div>校园服务</div></router-link>  
    </div>
    <div class="maskBox" v-if="show" @click="showNav"></div>  
    
  </div>
</template>

<script type="text/ecmascript-6">
export default {
   components: {},
   props: {},
   data () {
    return {
      show:false
    };
   },
   watch: {},
   computed: {},
   methods: {
    showNav(){
      if(this.show){
        this.show = false
      }else{
        this.show = true
      }
    }
  },
   mounted () {
    this.show = false
    let self =this 
    this.$router.afterEach((to,from)=>{
        self.show = false
    });
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Header.vue